import React from 'react';
import './App.css'; 
import Header from './components/Header/Header';
import HeroSection from './components/HeroSection/HeroSection'; 
import AboutProjectSection from './components/AboutProjectSection/AboutProjectSection'; 
import BenefitsSection from './components/BenefitsSection/BenefitsSection'; 
import ApplicationAreaSection from './components/ApplicationAreaSection/ApplicationAreaSection';
import OurTeamSection from './components/OurTeamSection/OurTeamSection';
import ToolsSection from './components/ToolsSection/ToolsSection';
import Footer from './components/Footer/Footer';


function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <AboutProjectSection /> 
      <BenefitsSection />
      <ApplicationAreaSection />
      <OurTeamSection />
      <ToolsSection />
      <Footer />

      {/* Seções temporárias com os novos IDs */}
      <section id="sobre-projeto" >
      </section>
      <section id="area-aplicacao">
      </section>
      <section id="nossa-equipe" >
      </section>
      <section id="ferramentas">
      </section>

      {/* Adicione um rodapé ou outras seções aqui */}
    </div>
  );
}

export default App;